export const ordering = {
  namespaced: true,
  state: {
    cart: {
      diet: {},
      dietId: null,
      boarders: [],
      user: null,
      customPackaging: 1,
      deliveryType: 1,
      paymentTypeId: 1,
      description: null,
      order: null,
      items: {}
    },
    orderObject: {
      id: null,
      dates: [],
      items: {}
    },
    orderingStep: 1,
    baseDeliveryPrice: null,
    basePackagingPrice: null,
    minOrderPrice: null,
    deliveryInfo: {},
    timeTypes: []
  },
  getters: {
    shoppingCart (state) {
      return state.cart
    },
    cartOrder (state) {
      return state.orderObject
    },
    deliveryInfo: state => state.deliveryInfo,
    shoppingCartEmpty (state) {
      return !Object.keys(state.cart.items).length
    },
    timeTypes: state => state.timeTypes,
    step: state => state.orderingStep,
    totalItemsPrice (state) {
      let total = 0
      for (const date in state.cart.items) {
        state.cart.items[date].flat().forEach(meal => {
          total += meal.price * meal.quantity
        })
      }
      return total
    },
    totalDeliveryPrice (state, getters) {
      if (!state.minOrderPrice) {
        return 0
      }
      const boardersCount = state.cart.boarders.length + +!!(state.cart.order)
      let totalDelivery = 0

      Object.keys(state.cart.items).forEach(date => {
        let totalDay = 0
        const day = state.cart.items[date]
        day.flat().forEach(meal => {
          totalDay += meal.price * meal.quantity * boardersCount
        })

        if (state.minOrderPrice > totalDay) {
          totalDelivery += state.baseDeliveryPrice
        }
      })
      return totalDelivery
    },
    totalPackagingPrice (state) {
      let mealCount = 0
      for (const date in state.cart.items) {
        const items = state.cart.items[date].flat()
        items.forEach(item => {
          mealCount += +item.quantity
        })
      }

      return state.basePackagingPrice * mealCount * (state.cart.boarders.length + !!state.cart.order)
    },
    totalOrderPrice (state, getters) {
      let total = getters.totalItemsPrice * (state.cart.boarders.length + +(!!state.cart.order))

      if (state.cart.deliveryType === 'Rozvoz') {
        if (!isNaN(getters.totalDeliveryPrice)) {
          total += getters.totalDeliveryPrice
        }
      }
      if (!state.cart.customPackaging) {
        total += getters.totalPackagingPrice
      }
      return total
    }
  },
  mutations: {
    reset (state) {
      state.cart = {
        diet: {},
        dietId: null,
        boarders: [],
        user: null,
        customPackaging: 1,
        deliveryType: 1,
        paymentTypeId: 1,
        description: null,
        order: null,
        items: {}
      }
      state.orderObject = {
        id: null,
        dates: [],
        boarders: []
      }
      state.orderingStep = 1
      this._vm.$forceUpdate()
    },
    updateTimeTypes (state, timeTypes) {
      state.timeTypes = timeTypes
    },
    goToOrderingStep (state, step) {
      state.orderingStep = step
    },
    updateShoppingCartStorage (state) {
      localStorage.setItem('shoppingCart', JSON.stringify(state.cart))
    },
    orderingStep3DeleteTime (state, { date, timeIndex }) {
      this._vm.$set(state.cart.items[date], timeIndex, [])
      if (!state.cart.items[date].filter(time => time.length).length) { // no selected food for date
        this._vm.$delete(state.cart.items, date)
      }
    },
    setDeliveryInfo (state, { deliveryPrice, packagingPrice, minPrice, institution, ...rest }) {
      state.baseDeliveryPrice = deliveryPrice
      state.basePackagingPrice = packagingPrice
      state.minOrderPrice = minPrice

      if (state.cart.diet.dietType === 'Instituční') {
        state.deliveryInfo = {
          street: institution.street,
          streetNumber: institution.streetNumber,
          city: institution.city,
          zip: institution.zip,
          name: institution.name
        }
      } else {
        state.deliveryInfo = {
          street: state.cart.user.deliveryStreet || state.cart.user.street,
          streetNumber: state.cart.user.deliveryStreetNumber || state.cart.user.streetNumber,
          city: state.cart.user.deliveryCity || state.cart.user.city,
          zip: state.cart.user.deliveryZip || state.cart.user.zip,
          name: `${state.cart.user.firstName} ${state.cart.user.lastName}`
        }
      }
    },
    setUser (state, userData) {
      state.cart.user = { ...userData, fullName: `${userData.firstName} ${userData.lastName}` }
    },
    setCart (state, payload) {
      state.cart = payload
    },
    setOrderDescription (state, description) {
      state.cart.description = description
    },
    setDeliveryType (state, dt) {
      state.cart.deliveryType = dt
    },
    setPackagingType (state, pt) {
      state.cart.customPackaging = pt
    },
    setOrderObject (state, order) {
      state.orderObject = order
    },
    setNewDelivery (state, val) {
      console.log(val)
      state.baseDeliveryPrice = val.district.deliveryPrice
      state.deliveryInfo = {
        street: val.street,
        streetNumber: val.number,
        city: val.city,
        zip: val.zip,
        name: `${state.cart.user.firstName} ${state.cart.user.lastName}`
      }
    }
  },
  actions: {
  }
}
